import type { Incident } from '../types/incident.types'
import { PriorityBadge } from './PriorityBadge'
import { StatusBadge } from './StatusBadge'
import { formatRelative } from '../../../utils/formatters'

interface IncidentRowProps {
  incident: Incident
  onSelect?: (id: number) => void
}

function assigneeLabel(incident: Incident): string {
  if (incident.assignee_user_id) return `User #${incident.assignee_user_id}`
  if (incident.assignee_team_id) return `Team #${incident.assignee_team_id}`
  return 'Unassigned'
}

export function IncidentRow({ incident, onSelect }: IncidentRowProps): JSX.Element {
  return (
    <tr
      onClick={onSelect ? () => onSelect(incident.id) : undefined}
      className={`border-b border-gray-100 ${onSelect ? 'cursor-pointer hover:bg-gray-50' : ''}`}
    >
      <td className="px-4 py-3 text-xs font-medium text-gray-500">#{incident.id}</td>
      <td className="px-4 py-3 text-sm font-medium text-gray-900">{incident.title}</td>
      <td className="px-4 py-3"><PriorityBadge priority={incident.priority} /></td>
      <td className="px-4 py-3"><StatusBadge status={incident.status} /></td>
      <td className="px-4 py-3 text-sm text-gray-600">{assigneeLabel(incident)}</td>
      <td className="px-4 py-3 text-sm text-gray-500">{formatRelative(incident.created_at)}</td>
    </tr>
  )
}
